import React, { Component } from 'react';
import { connect } from 'react-redux'

import ResponsiveComponent from './components/responsive/responsive';

import DesktopErrorComponent from './components/responsive/desktop/error/error';
import MobileErrorComponent from './components/responsive/mobile/error/error';
import DesktopSplashComponent from './components/responsive/desktop/splash/splash';
import MobileSplashComponent from './components/responsive/mobile/splash/splash';
import DesktopHomeComponent from './components/responsive/desktop/home/home';
import MobileHomeComponent from './components/responsive/mobile/home/home';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {updateApplicationConfiguration} from './utils/api/applicationApiProxy.js';
import {updateSnoozePropertyConfiguration} from './utils/api/snoozePropertyApiProxy.js';
import {loadUserById} from './utils/api/userApiProxy';

const queryString = require('query-string');

const logger = require('./utils/logger/logger');
const stateManager = require('./utils/state/stateManager.js');
const configurationManager = require('./utils/config/configurationManager');
const fatalErrorAction = require('./utils/state/actions/error/fatalErrorAction');

const storageUtil = require('./utils/storage/storageUtil');
const stringUtil = require('./utils/string/stringUtil.js');
const basketUtil = require('./utils/basket/basketUtil');
const constants = require('./utils/domain/constants');

class App extends Component 
{
    constructor(props)
    {
        super(props);
        this.state = {};
        this.state.isLoaded = false;
    
        this.initializeHost();
    }

    render()
    {
        if (!stringUtil.isStringNullOrEmpty(stateManager.getStore().getState().fatalError))
        {
          return <ResponsiveComponent
                    mobile={<MobileErrorComponent/>}
                    desktop={<DesktopErrorComponent/>}/>
        }

        if (stringUtil.isStringNullOrEmpty(stateManager.getStore().getState().applicationId))
        {
            var store = stateManager.getStore();
            store.dispatch(fatalErrorAction.createAction("Application is accessed without application id"));
            return null;
        }

        if (!this.state.isLoaded)
        {
            return this.renderLoading();
        }

        return this.renderComponent();
    }

    renderComponent()
    {
        document.title = stateManager.getStore().getState().applicationTitle;

        if (!stringUtil.isStringNullOrEmpty(stateManager.getStore().getState().themeId))
           document.documentElement.setAttribute('data-theme', stateManager.getStore().getState().themeId)

        if (!stringUtil.isStringNullOrEmpty(stateManager.getStore().getState().favIconUrl))
        {
            var favicon = document.getElementById("favicon");
            favicon.href = stateManager.getStore().getState().favIconUrl;
        }

        if(basketUtil.isCurrentBasketForPaymentOverPhone())
            stateManager.getStore().getState().currentComponent = "basket";
        else
            stateManager.getStore().getState().currentComponent = "store";

        return <div>
                    <ResponsiveComponent
                        desktop={<DesktopHomeComponent/>}
                        mobile={<MobileHomeComponent/>}
                    />
                    <ToastContainer />
                </div>
    }

    renderLoading()
    {
        var store = stateManager.getStore();

        storageUtil.initializeStorage()
        .then(async _ => {
                try
                {
                    await configurationManager.loadConfiguration();
                    await updateApplicationConfiguration();
                    logger.resetGlobalContext();

                    await updateSnoozePropertyConfiguration();

                    const state = stateManager.getStore().getState();
                    if(basketUtil.isCurrentBasketForPaymentOverPhone())
                    {
                        if(!state.basket.isPaymentOverPhoneApplicableToSale)
                        {
                            store.dispatch(fatalErrorAction.createAction("The payment has either been collected or sale has been cancelled!"));
                            return null;
                        }

                        const user = await loadUserById(stateManager.getStore().getState().basket.order.customerId);
                        state.user = 
                        {
                            ...user,
                            isUserVerified: true,
                            isUserRegistered: true,
                        }
                    }
                  
                    this.state.isLoaded = true;

                    this.setState({});
                }
                catch(error)
                {
                    store.dispatch(fatalErrorAction.createAction(error));
                }
                
            }, error =>
            {
                store.dispatch(fatalErrorAction.createAction(error));
            });

        return <ResponsiveComponent
                    desktop={<DesktopSplashComponent/>}
                    mobile={<MobileSplashComponent/>}
                    />
    }

    initializeHost()
    {
        this.initializeHostViaSearch();
        if (stringUtil.isStringNullOrEmpty(stateManager.getStore().getState().applicationId))
            this.initializeHostViaHash();
    }

    initializeHostViaSearch()
    {
        if (this.props.location != null && this.props.location.search != null)
        {
            var parsedQueryString = queryString.parse(this.props.location.search);
            stateManager.getStore().getState().applicationId = parsedQueryString.applicationId;
        }
    }

    initializeHostViaHash()
    {
        if (window != null && window.location != null && !stringUtil.isStringNullOrEmpty(window.location.hash) && window.location.hash.includes("?"))
        {
            var rawQueryString = window.location.hash.split("?")[1];
            var parsedQueryString = queryString.parse(rawQueryString);

            if(parsedQueryString.applicationId)
            {
                stateManager.getStore().getState().applicationId = parsedQueryString.applicationId;
                stateManager.getStore().getState().currentMode = constants.applicationMode.webApp;
            }
            else if(parsedQueryString.paymentLinkId)
            {
                stateManager.getStore().getState().paymentLinkId = parsedQueryString.paymentLinkId;
                stateManager.getStore().getState().applicationId = parsedQueryString.paymentLinkId;
                stateManager.getStore().getState().currentMode = constants.applicationMode.overPhonePayment;
            }
        }
    }
}

const mapStateToProps = state => 
{
    return { 
        fatalError: state.fatalError,
    }
}

export default connect(mapStateToProps)(App)

